import React, { useContext } from 'react'
import { AuthContext } from '../../../Api/firebase'
import { PLL_IMAGES } from '../../../Config/config'
import { ProfileCon } from './styles'

export const UserProfile: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { profileUrl } = useContext(AuthContext)!

  return (
    <ProfileCon>
      {!profileUrl && (
        <div className="defaultProfileCon">
          <img  className="defaultImg" src={PLL_IMAGES.defaultProfile} alt="Pll logo" />
        </div>
      )}
      {profileUrl && <img className='pImg' src={profileUrl} alt="User profile" />}
    </ProfileCon>
  )
}
